import { Component, ChangeDetectionStrategy } from '@angular/core';
import { OutlookMsalService } from '@maximizer/outlook/shared/data-access';
import { TranslatePipe } from '@ngx-translate/core';
import { OUTLOOK_SHARED_UI } from '@maximizer/outlook/shared/ui';
import { TrackEventService } from '@maximizer/core/shared/data-access';
import {
  EventAction,
  EventJourney,
  EventModule,
} from '@maximizer/outlook/shared/domain';

@Component({
  selector: 'maximizer-outlook-msal-account-warning',
  template: `<maximizer-outlook-status-message
    [type]="'warning'"
    [message]="'outlook.auth.msal.accountWarning' | translate"
    [actionText]="'outlook.buttons.logIn' | translate"
    (action)="login()"
    [actionButtonId]="'outlook-auth-msal-accountWarning-login'"
  >
  </maximizer-outlook-status-message>`,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe, OUTLOOK_SHARED_UI],
})
export class MsalAccountWarningComponent {
  constructor(
    private readonly msalService: OutlookMsalService,
    private readonly tracker: TrackEventService,
  ) {}

  login(): void {
    this.tracker.trackEvent({
      module: EventModule.Notification,
      journey: EventJourney.StatusMessage,
      action: EventAction.Clicked,
      metadata: {
        event: 'login',
        type: 'microsoft-login',
      },
    });

    this.msalService.loginPopup();
  }
}
